import React, { Component } from 'react'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import SEO from '../components/seo'

// import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'

import Layout from '../components/layout/layout'

import '../global-scss/index.scss'

// eslint-disable-next-line
import threedmssImage from '../queries/threedmssImage'


const IndexPage = class extends Component {
  constructor(props) {
    super(props)

    this.state = { showContactModal: false }
  }

  launchContactModal = () => {
    console.log(this.state.showContactModal)
    this.setState({showContactModal: true})
  }
  closeContactModal = () => {this.setState({showContactModal: false})}

  render() {
    const { location } = this.props

    return (
      <React.Fragment>
        <SEO title="" />
        <Layout
          location={location}
          setAuthenticated={(is_signed_in) => this.setState({authenticated: is_signed_in})}
          no_student_view={true}
          className="home-background"
        >
          <Container fluid className="d-flex h-100 flex-column p-3">
            <Row className="d-flex flex-wrap-reverse">
              <Col xs={12} className="d-block d-md-none">
                <Img
                  fluid={this.props.data.image1.childImageSharp.fluid}
                  alt="Headshot of M'Kenna smiling"
                  className="m-3"
                  style={{border: '10px solid white', borderRadius: '50%'}}
                />
              </Col>
              <Col xs={12} md={7} className="d-flex align-items-center">
                <div>
                  <h1 className="home-title-mkenna">
                    Meet M'Kenna!
                  </h1>
                  <p className="home-text">This is M'Kenna. M'Kenna loves basketball and track. She also loves spending time with her friends. When M'Kenna was 13, something strange started happening. She started losing weight and feeling sick all of the time.</p>
                  <Link to="/unit-introduction/overview" className="home-yellow-button p-2 rounded"><div className="btn w-100 bold-me">Get Started</div></Link>
                </div>
              </Col>
              <Col md={5} className="d-none d-md-block">
                <Img
                  fluid={this.props.data.image1.childImageSharp.fluid}
                  alt="Headshot of M'Kenna smiling"
                  className="m-3"
                  style={{border: '10px solid white', borderRadius: '50%'}}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <div>
                  <a
                    href="https://media.bscs.org/3dmss/documents/3dmss_student_edition_pdf_final.pdf"
                    target="_blank"
                    className="home-yellow-text"
                  >
                    Access the PDF of this unit.&nbsp;<sup><i style={{fontSize: '.65rem'}} className="fas fa-external-link-alt"></i></sup>
                  </a>
                </div>
                <div>
                  <Link to="/hard-pronunciations" className="home-yellow-text">
                    Listen to the pronunciation of challenging words.
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </Layout>
      </React.Fragment>
    )
  }
}

export default IndexPage

export const query = graphql`
  query {
    image1: file(relativePath: { eq: "home.jpg" }) {
      ...threedmssImage
    }
  }
`
